import React from "react";
import "./About.css";
function About() {
  return (
    <div className="about">
      <div className="container">
        <div className="about__container">
          <p className="about__text">
            ..и совершенно случайно мы <br /> знаем что ей нравится.. ведь она{" "}
            <br />
            нам тоже намекнула...
          </p>
        </div>
      </div>
    </div>
  );
}

export default About;
